import React, { Component } from 'react';
import { HeaderSub } from '../../Common/HeaderSub'
import { HeaderMain } from '../../Common/HeaderMain'
import { Footer } from '../../Common/Footer'
import { SimpleFileUpLoad } from '../../Common/SimpleFileUpLoad'

import { MyPage } from './MyPage';                      //마이페이지 메인
import { AccountList } from './AccountList';            //내거래처
import { ApprovalList } from './ApprovalList';          //내거래처 승인
import { WholeRequest } from './WholeRequest';          //거래처 등록(도매)
import { DealHistory } from './DealHistory';            //거래내역
import { MyInfoCheck } from './MyInfoCheck';            //내정보수정시 비번 검증
import { MyInfo } from './MyInfo';                      //내정보수정
import { StoreInfo } from './StoreInfo';                //매장정보 수정
import { EmpList } from '../StoreMgr/EmpList';          //직원관리
import { TeamMatching } from '../StoreMgr/TeamMatching';//직원관리
import { ServiceCenter } from '../Etc/ServiceCenter';   //고객센터
import { Withdrawal } from '../Etc/Withdrawal';         //회원탈퇴
import { StoreDtl } from '../../Search/Store/StoreDtl'; //매장정보 상세
import { ChargePoint } from '../../Common/ChargePoint'; //포인트충전
import { RegisterCard } from '../../Common/RegisterCard'; //카드등록
import { PointCheck } from '../../Common/PointCheck'; //포인트충전성공
import { PaymentList } from '../../Common/PaymentList'; //결제내역

import { Privacypolicy } from '../../Account/MemberMgr/Privacypolicy';
import { Termsofservice } from '../../Account/MemberMgr/Termsofservice';
import { RefundPolicy } from '../../Account/MemberMgr/RefundPolicy';

import { Big3Common } from '../../../js/IncludeManager'

/* 개발담당:양유빈
 * 화면기능:마이페이지 인덱스 페이지
 * 세부설명:
*/

export class Index extends Component {
    static displayName = Index.name;

    constructor(props) {
        super(props);
        this.state = {
            RenderName: this.CompName.MyPage,  //기본 컴포넌트 할당
            ContentState: null
        };
        this.CsName = Big3Common.ContentState;
    }
    //호출할 컴포넌트 이름
    CompName = {
        "MyPage": "MyPage",
        "AccountList": "AccountList",
        "WholeRequest":"WholeRequest",
        "ApprovalList": "ApprovalList",
        "DealHistory": "DealHistory",
        "MyInfoCheck": "MyInfoCheck",
        "MyInfo": "MyInfo",
        "StoreInfo": "StoreInfo",
        "PhotoUpload": "PhotoUpload",
        "BusinessInfo": "BusinessInfo",
        "EmpList": "EmpList",
        "ServiceCenter": "ServiceCenter",
        "Withdrawal":"Withdrawal",
        "StoreDtl": "StoreDtl",
        "TeamMatching": "TeamMatching",
        "Privacypolicy": "Privacypolicy",
        "Termsofservice": "Termsofservice",
        "RefundPolicy": "RefundPolicy",
        "ChargePoint": "ChargePoint",
        "RegisterCard": "RegisterCard",
        "PointCheck": "PointCheck",
        "PaymentList": "PaymentList"
    }
    //초기화
    componentDidMount() {
        const Param_Alim_Idx = Big3Common.Util.GetParams("alim_idx"); 
        const Param_Uid = Big3Common.Util.GetParams("uid"); 
        if (Param_Alim_Idx === "11") {
            this.setState({
                RenderName: this.CompName.AccountList
            });
        }
        if (Param_Alim_Idx === "13") {
            const ContentState = {
                [this.CsName.Uid]: Param_Uid
            }
            this.setState({
                ContentState: ContentState,
                RenderName: this.CompName.StoreDtl
            });
        }
    }
    componentWillUnmount() {
        Big3Common.HistoryBackToClearBackdoor();
    }
    renderPick() {
        if (this.state.RenderName === this.CompName.MyPage) {
            //마이페이지 메인화면
            return (
                <div>
                    <HeaderMain
                        HeaderSub={{ Title: "마이페이지", LinkYn: "N", LinkUrl: "", ComponentUrl: "" }}
                    />
                    <MyPage
                        RenderComponent={(RenderName) => this.setState({ RenderName: RenderName })}
                    />
                    <Footer fillName="icon5" />
                </div>
            );
        }
        else if (this.state.RenderName === this.CompName.AccountList) {
            //거래처 > 내거래처
            return (
                <div>
                    <HeaderSub
                        HeaderTitle="거래처"
                        ComponentUrl="MyPage"
                        RenderComponent={(RenderName) => this.setState({ RenderName: RenderName })}
                        ComponentName={this.state.RenderName}
                    />
                    <AccountList
                        RenderComponent={(RenderName, ContentState) => this.setState({ RenderName: RenderName, ContentState: ContentState })}
                        ContentState={this.state.ContentState}
                    />
                </div>
            );
        }
        else if (this.state.RenderName === this.CompName.StoreDtl) {

            //거래처 > 내거래처 > 매장상세
            return (
                <div>
                    <StoreDtl
                        RenderComponent={(RenderName, ContentState) => this.setState({ RenderName: RenderName, ContentState: ContentState })}
                        ContentState={this.state.ContentState}
                    />

                </div>
            );
        }
        else if (this.state.RenderName === this.CompName.DealHistory) {
            //거래처 > 내거래처 > 거래내역
            return (
                <div>
                    <HeaderSub
                        HeaderTitle="거래내역"
                        ComponentUrl="AccountList"
                        RenderComponent={(RenderName) => this.setState({ RenderName: RenderName })}
                        ComponentName={this.state.RenderName}
                    />
                    <DealHistory
                        RenderComponent={(RenderName, ContentState) => this.setState({ RenderName: RenderName, ContentState: ContentState })}
                        ContentState={this.state.ContentState}
                    />
                </div>
            );
        }
        else if (this.state.RenderName === this.CompName.ApprovalList) {
            //거래처 > 승인대기
            return (
                <div>
                    <HeaderSub
                        HeaderTitle="거래처"
                        ComponentUrl="MyPage"
                        RenderComponent={(RenderName) => this.setState({ RenderName: RenderName })}
                        ComponentName={this.state.RenderName}
                    />
                    <ApprovalList
                        RenderComponent={(RenderName, ContentState) => this.setState({ RenderName: RenderName, ContentState: ContentState })}
                        ContentState={this.state.ContentState}
                    />
                </div>
            );
        }
        else if (this.state.RenderName === this.CompName.WholeRequest) {
            //거래처 > 승인대기
            return (
                <div>
                    <HeaderSub
                        HeaderTitle="거래처"
                        ComponentUrl="MyPage"
                        RenderComponent={(RenderName) => this.setState({ RenderName: RenderName })}
                        ComponentName={this.state.RenderName}
                    />
                    <WholeRequest
                        RenderComponent={(RenderName, ContentState) => this.setState({ RenderName: RenderName, ContentState: ContentState })}
                        ContentState={this.state.ContentState}
                    />
                </div>
            );
        }
        else if (this.state.RenderName === this.CompName.MyInfoCheck) {
            //내정보 > 비밀번호확인
            return (
                <div>
                    <HeaderSub
                        HeaderTitle="내정보"
                        ComponentUrl="MyPage"
                        RenderComponent={(RenderName) => this.setState({ RenderName: RenderName })}
                        ComponentName={this.state.RenderName}
                    />
                    <MyInfoCheck
                        RenderComponent={(RenderName, ContentState) => this.setState({ RenderName: RenderName, ContentState: ContentState })}
                    />
                </div>
            )
        }
        else if (this.state.RenderName === this.CompName.MyInfo) {
            //내정보 > 비밀번호확인 > 내정보 변경
            return (
                <div>
                    <HeaderSub
                        HeaderTitle="내정보"
                        ComponentUrl="MyPage"
                        RenderComponent={(RenderName) => this.setState({ RenderName: RenderName })}
                        ComponentName={this.state.RenderName}
                    />
                    <MyInfo
                        RenderComponent={(RenderName) => this.setState({ RenderName: RenderName })}
                        ContentState={this.state.ContentState}
                    />
                </div>
            )
        }
        else if (this.state.RenderName === this.CompName.StoreInfo) {
            //매장정보수정 > 내정보
            return (
                <div>
                    <HeaderSub
                        HeaderTitle="매장정보수정"
                        ComponentUrl="MyPage"
                        RenderComponent={(RenderName) => this.setState({ RenderName: RenderName })}
                        ComponentName={this.state.RenderName}
                    />
                    <StoreInfo
                        RenderComponent={(RenderName, ContentState) => this.setState({ RenderName: RenderName, ContentState: ContentState })}
                        ContentState={this.state.ContentState}
                    />
                </div>
            )
        }
        else if (this.state.RenderName === this.CompName.PhotoUpload) {
            //매장정보수정 > 내정보 > 매장사진
            return (
                <div>
                    <HeaderSub
                        HeaderTitle="매장사진"
                        ComponentUrl="StoreInfo"
                        RenderComponent={(RenderName, ContentState) => this.setState({ RenderName: RenderName, ContentState: ContentState })}
                        ContentState={this.state.ContentState}
                        ComponentName={this.state.RenderName}
                    />
                    <SimpleFileUpLoad
                        RenderComponent={(RenderName, ContentState) => this.setState({ RenderName: RenderName, ContentState: ContentState })}
                        ContentState={this.state.ContentState}
                        ComponentUrl="StoreInfo"
                    />
                </div>
            )
        }
        else if (this.state.RenderName === this.CompName.BusinessInfo) {
            //매장정보수정 > 내정보 > 사업자등록증 업로드
            return (
                <div>
                    <HeaderSub
                        HeaderTitle="사업자등록증 등록"
                        ComponentUrl="StoreInfo"
                        RenderComponent={(RenderName, ContentState) => this.setState({ RenderName: RenderName, ContentState: ContentState })}
                        ContentState={this.state.ContentState}
                        ComponentName={this.state.RenderName}
                    />
                    <SimpleFileUpLoad
                        RenderComponent={(RenderName, ContentState) => this.setState({ RenderName: RenderName, ContentState: ContentState })}
                        ContentState={this.state.ContentState}
                        ComponentUrl="StoreInfo"
                    />
                </div>
            )
        }
        else if (this.state.RenderName === this.CompName.EmpList) {
            //직원관리
            return (
                <div>
                    <HeaderSub
                        HeaderTitle="직원계정관리"
                        ComponentUrl="MyPage"
                        RenderComponent={(RenderName) => this.setState({ RenderName: RenderName })}
                        ComponentName={this.state.RenderName}
                    />
                    <EmpList
                        RenderComponent={(RenderName) => this.setState({ RenderName: RenderName })}
                        ContentState={this.state.ContentState}
                    />
                </div>
            )
        }
        else if (this.state.RenderName === this.CompName.TeamMatching) {
            //직원관리
            return (
                <div>
                    <HeaderSub
                        HeaderTitle="삼촌관리"
                        ComponentUrl="MyPage"
                        RenderComponent={(RenderName) => this.setState({ RenderName: RenderName })}
                        ComponentName={this.state.RenderName}
                    />
                    <TeamMatching
                        RenderComponent={(RenderName) => this.setState({ RenderName: RenderName })}
                        ContentState={this.state.ContentState}
                    />
                </div>
            )
        }
        else if (this.state.RenderName === this.CompName.ServiceCenter) {
            //고객센터
            return (
                <div>
                    <HeaderSub
                        HeaderTitle="고객센터"
                        ComponentUrl="MyPage"
                        RenderComponent={(RenderName) => this.setState({ RenderName: RenderName })}
                        ComponentName={this.state.RenderName}
                    />
                    <ServiceCenter
                        RenderComponent={(RenderName) => this.setState({ RenderName: RenderName })}
                        ContentState={this.state.ContentState}
                    />
                </div>
            )
        }
        else if (this.state.RenderName === this.CompName.Withdrawal) {
            //고객센터
            return (
                <div>
                    <HeaderSub
                        HeaderTitle="회원탈퇴"
                        ComponentUrl="MyPage"
                        RenderComponent={(RenderName) => this.setState({ RenderName: RenderName })}
                        ComponentName={this.state.RenderName}
                    />
                    <Withdrawal
                        RenderComponent={(RenderName) => this.setState({ RenderName: RenderName })}
                        ContentState={this.state.ContentState}
                    />
                </div>
            )
        }
        else if (this.state.RenderName === this.CompName.Privacypolicy) {
            return (
                <div>
                    <HeaderSub
                        HeaderTitle="서비스이용약관"
                        ComponentUrl="MyPage"
                        RenderComponent={(RenderName, ContentState) => this.setState({ RenderName: RenderName, ContentState: ContentState })}
                        ContentState={this.state.ContentState}
                        ComponentName={this.state.RenderName}
                    />
                    <Privacypolicy
                        RenderComponent={(RenderName, ContentState) => this.setState({ RenderName: RenderName, ContentState: ContentState })}
                        ContentState={this.state.ContentState}
                    />
                </div>
            );
        }
        else if (this.state.RenderName === this.CompName.Termsofservice) {
            return (
                <div>
                    <HeaderSub
                        HeaderTitle="개인정보 취급방법"
                        ComponentUrl="MyPage"
                        RenderComponent={(RenderName, ContentState) => this.setState({ RenderName: RenderName, ContentState: ContentState })}
                        ContentState={this.state.ContentState}
                        ComponentName={this.state.RenderName}
                    />
                    <Termsofservice
                        RenderComponent={(RenderName, ContentState) => this.setState({ RenderName: RenderName, ContentState: ContentState })}
                        ContentState={this.state.ContentState}
                    />
                </div>
            );
        }
        else if (this.state.RenderName === this.CompName.RefundPolicy) {
            return (
                <div>
                    <HeaderSub
                        HeaderTitle="결제 이용약관"
                        ComponentUrl="MyPage"
                        RenderComponent={(RenderName, ContentState) => this.setState({ RenderName: RenderName, ContentState: ContentState })}
                        ContentState={this.state.ContentState}
                        ComponentName={this.state.RenderName}
                    />
                    <RefundPolicy
                        RenderComponent={(RenderName, ContentState) => this.setState({ RenderName: RenderName, ContentState: ContentState })}
                        ContentState={this.state.ContentState}
                    />
                </div>
            );
        }
        else if (this.state.RenderName === this.CompName.ChargePoint) {

            //포인트충전
            return (
                <div>
                    <HeaderSub
                        HeaderTitle="포인트충전"
                        ComponentUrl="MyPage"
                        RenderComponent={(RenderName) => this.setState({ RenderName: RenderName })}
                        ComponentName={this.state.RenderName}
                    />
                    <ChargePoint
                        RenderComponent={(RenderName, ContentState) => this.setState({ RenderName: RenderName, ContentState: ContentState })}
                        ContentState={this.state.ContentState}
                    />

                </div>
            );
        }
        else if (this.state.RenderName === this.CompName.RegisterCard) {

            //카드등록
            return (
                <div>
                    <RegisterCard
                        RenderComponent={(RenderName, ContentState) => this.setState({ RenderName: RenderName, ContentState: ContentState })}
                        ContentState={this.state.ContentState}
                    />

                </div>
            );
        }
        else if (this.state.RenderName === this.CompName.PointCheck) {

            //포인트충전 성공
            return (
                <div>
                    <PointCheck
                        RenderComponent={(RenderName, ContentState) => this.setState({ RenderName: RenderName, ContentState: ContentState })}
                        ContentState={this.state.ContentState}
                    />

                </div>
            );
        }
        else if (this.state.RenderName === this.CompName.PaymentList) {

            //결제내역
            return (
                <div>
                    <HeaderSub
                        HeaderTitle="결제내역"
                        ComponentUrl="MyPage"
                        RenderComponent={(RenderName) => this.setState({ RenderName: RenderName })}
                        ComponentName={this.state.RenderName}
                    />
                    <PaymentList
                        RenderComponent={(RenderName, ContentState) => this.setState({ RenderName: RenderName, ContentState: ContentState })}
                        ContentState={this.state.ContentState}
                    />

                </div>
            );
        }
        else {
            return (
                <div>
                    페이지가 없습니다
                </div>
            )
        }
    }
    render() {
        let RnderAct = this.renderPick();
        return (
            <div>
                {RnderAct}
            </div>
        );
    }
}
